<template>
	<div v-if="hasActiveFilters" class="row py-5 pt-0 xs:pb-5">
		<div class="flex w-full flex-wrap justify-center gap-4">
			<filter-pill
				v-if="searchTerm"
				:value="searchTerm"
				:label="searchLabel"
				@remove="$emit('update:searchTerm', '')"
			/>
			<filter-pill
				v-if="filters.selectedTenant && tenants?.length > 1 && selectedTenantName"
				label="tenant"
				:value="selectedTenantName"
				@remove="clearTenant"
			/>
			<filter-pill
				v-if="filters.selectedAccount"
				label="account"
				:value="computedAccountName"
				@remove="clearAccount"
			/>
			<filter-pill
				v-if="filters.dateAddedFrom || filters.dateAddedTo"
				label="date"
				:value="formatDates(filters.dateAddedFrom, filters.dateAddedTo)"
				@remove="clearDates"
			/>
			<filter-pill
				v-if="filters.status"
				label="status"
				:value="filters.status"
				@remove="$emit('update:filters', { ...filters, status: null })"
			/>
			<slot></slot>
		</div>
	</div>
</template>

<script>
import moment from 'moment'

export default {
	inject: ['tenants'],
	props: {
		filters: {
			type: Object,
			required: true
		},
		searchTerm: String,
		searchLabel: {
			type: String,
			default: 'search'
		},
		selectedTenantName: String,
		selectedAccountName: String,
		accounts: {
			type: Array,
			default: () => []
		}
	},
	emits: ['update:filters', 'update:searchTerm', 'tenant-cleared', 'account-cleared', 'dates-cleared'],
	computed: {
		hasActiveFilters() {
			const hasTenantFilter = this.filters.selectedTenant && this.tenants?.length > 1
			return (
				this.searchTerm ||
				hasTenantFilter ||
				this.filters.selectedAccount ||
				this.filters.dateAddedFrom ||
				this.filters.dateAddedTo ||
				this.filters.status
			)
		},
		computedAccountName() {
			if (this.filters.selectedAccount === '-1') return 'Unassigned'
			if (this.selectedAccountName) return this.selectedAccountName

			const account = this.accounts.find((a) => a.id === parseInt(this.filters.selectedAccount))
			return account?.name || 'Unknown Account'
		}
	},
	methods: {
		formatDates(date1, date2) {
			if (date1 && date2) {
				return moment(date1).format('Do MMM YY') + ' to ' + moment(date2).format('Do MMM YY')
			}
			return date1 ? moment(date1).format('Do MMM YY') : null
		},
		clearTenant() {
			this.$emit('update:filters', { ...this.filters, selectedTenant: '', selectedAccount: null })
			this.$emit('tenant-cleared')
		},
		clearAccount() {
			this.$emit('update:filters', { ...this.filters, selectedAccount: null })
			this.$emit('account-cleared')
		},
		clearDates() {
			this.$emit('update:filters', {
				...this.filters,
				dateAddedFrom: null,
				dateAddedTo: null
			})
			this.$emit('dates-cleared')
		}
	}
}
</script>
